/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_New_Group_TitleInputs */

const cs_chat_new_group_title = /** @type {(inputs: Chat_New_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název skupiny`)
};

const en_chat_new_group_title = /** @type {(inputs: Chat_New_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group name`)
};

/**
* | output |
* | --- |
* | "Group name" |
*
* @param {Chat_New_Group_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_new_group_title = /** @type {((inputs?: Chat_New_Group_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_New_Group_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_new_group_title(inputs)
	return cs_chat_new_group_title(inputs)
});